<template>
  <div class="vidicon_control" @click.stop>
    <div class="device_title">
      <span>当前设备：</span>
      <span>{{
        currentDevice && currentDevice.deviceName
          ? currentDevice.deviceName
          : '- -'
      }}</span>
    </div>
    <div class="direction_module">
      <div class="direction_module_circle">
        <div
          class="direction_module_circle_button_of_one"
          :style="item.styleObj"
          v-for="item in directionModuleButtonList"
          :key="item.title"
          @mousedown="operationOfButton(item, 'direction', 'down')"
          @mouseup="operationOfButton(item, 'direction', 'up')"
        >
          <img :src="item.icon" :alt="item.title" />
        </div>
      </div>
    </div>
    <div class="zoom_module">
      <div class="zoom_module_title">镜头</div>
      <div
        :class="['zoom_module_button_of_one', item.class]"
        v-for="item in zoomModuleButtonList"
        :key="item.title"
        @mousedown="operationOfButton(item, 'zoom', 'down')"
        @mouseup="operationOfButton(item, 'zoom', 'up')"
      >
        <img :src="item.icon" :alt="item.title" />
      </div>
    </div>
    <div class="footer_module">
      <div class="confirm_btn" @click="operationOfConfirm">完成</div>
    </div>
  </div>
</template>

<script>
import { toFormData } from '../../utils/tool'
export default {
  name: 'vidiconControl',
  data() {
    return {
      directionModuleButtonList: [
        {
          title: '上',
          icon: require('../../assets/img/vidiconControl/top.png'),
          iconGray: require('../../assets/img/vidiconControl/top.png'),
          iconHighLight: require('../../assets/img/vidiconControl/top_highlight.png'),
          styleObj: {
            top: '5px',
            left: '50%',
            transform: 'translateX(-50%)'
          },
          action: 1
        },
        {
          title: '右',
          icon: require('../../assets/img/vidiconControl/right.png'),
          iconGray: require('../../assets/img/vidiconControl/right.png'),
          iconHighLight: require('../../assets/img/vidiconControl/right_highlight.png'),
          styleObj: {
            top: '50%',
            right: '5px',
            transform: 'translateY(-50%)'
          },
          action: 4
        },
        {
          title: '下',
          icon: require('../../assets/img/vidiconControl/bottom.png'),
          iconGray: require('../../assets/img/vidiconControl/bottom.png'),
          iconHighLight: require('../../assets/img/vidiconControl/bottom_highlight.png'),
          styleObj: {
            bottom: '5px',
            left: '50%',
            transform: 'translateX(-50%)'
          },
          action: 2
        },
        {
          title: '左',
          icon: require('../../assets/img/vidiconControl/left.png'),
          iconGray: require('../../assets/img/vidiconControl/left.png'),
          iconHighLight: require('../../assets/img/vidiconControl/left_highlight.png'),
          styleObj: {
            top: '50%',
            left: '5px',
            transform: 'translateY(-50%)'
          },
          action: 3
        }
      ],
      zoomModuleButtonList: [
        {
          title: '加',
          icon: require('../../assets/img/vidiconControl/icon_jia_black.png'),
          iconGray: require('../../assets/img/vidiconControl/icon_jia_white.png'),
          iconHighLight: require('../../assets/img/vidiconControl/icon_jia_black.png'),
          action: 11
        },
        {
          title: '减',
          icon: require('../../assets/img/vidiconControl/icon_jian_black.png'),
          iconGray: require('../../assets/img/vidiconControl/icon_jian_white.png'),
          iconHighLight: require('../../assets/img/vidiconControl/icon_jian_black.png'),
          class: 'm_l24',
          action: 12
        }
      ],
      currentDevice: {}
    }
  },
  props: {
    currentPlayItem: {
      type: Object,
      default: null
    },
    clientForZRTC: {
      type: Object,
      default: null
    }
  },
  watch: {
    currentPlayItem: function (newval) {
      // 新增逻辑：
      // 选择教室的时候高管理球机控制弹框：
      this.$parent.setForActiveForOperationItem('')
      // 老逻辑：
      if (newval.hasOwnProperty('roomId') ||  newval.hasOwnProperty('roomID')) {
        this.getCameraCode()
      }
    }
  },
  computed: {
    role: function () {
      let role = 2
      if (this.currentPlayItem) {
        if (this.currentPlayItem.hasOwnProperty('role')) {
          role = this.currentPlayItem.role
        } 
        if (this.currentPlayItem.hasOwnProperty('masterSpeaker')) {
          role = this.currentPlayItem.masterSpeaker ? 1 : 2
        }
      }
      return role
    },
    currentUserPlaceForClassRoom: function () {
      let currentUserPlaceForClassRoom = ''
      if (this.currentPlayItem) {
        currentUserPlaceForClassRoom = this.currentPlayItem.roomId || this.currentPlayItem.roomID
      }
      return currentUserPlaceForClassRoom
    }
  },
  created () {
    this.getCameraCode()
  },
  // 针对球控，点击框外任意地方都要使球控框消失：
  mounted () {
    const _that = this
    document.addEventListener('click', function () {
      if (_that.$parent) {
        if (_that.$parent.activeForOperationItem === 'adjust') {
          console.log('关闭球控')
          _that.$parent.setForActiveForOperationItem('')
        } 
      }
    })
  },
  methods: {
    async getCameraCode () {
      try {
        if (!this.currentUserPlaceForClassRoom) return this.$message.error('无法获取当前教室')
        const params = {
          classRoomCode: this.currentUserPlaceForClassRoom,
          roleType: this.role
        }
        const result = await this.$http.getCameraCode(params)
        if (result.code !== 200) return this.$message.error(result.msg)
        this.currentDevice = (result.rt || [])[0]
        console.log(this.currentDevice, 'this.currentDevice')
      } catch (err) {
        console.log(err)
      }
    },
    async liveDeviceControl (action) {
      try {
        if (!this.currentDevice) return this.$message.error('没有当前设备')
        // 以前是调接口：
        // const params = {
        //   mainLiveId: this.$route.query.liveId,
        //   deviceCode: this.currentDevice.cameraCode,
        //   action,
        //   roomId: this.currentUserPlaceForClassRoom
        // }
        // console.log(params)
        // const result = await this.$http.liveDeviceControl(toFormData(params))
        // if (result.code !== 200) return this.$message.error(result.msg)
        // const { rt: resultReally } = result
        // if (resultReally.resultStatus !== 1) return this.$message.error(resultReally.resultMessage)
        // 现在改为调SDK方法：
        console.log(this.clientForZRTC, 'clientForZRTCclientForZRTC')
        console.log(this.currentDevice.cameraCode, action, 5, 500, 'ptz')
        if (this.clientForZRTC) {
          this.clientForZRTC.ptz(this.currentDevice.cameraCode, action, 5, 500)
        }
      } catch (err) {
        console.log(err)
      }
    },
    operationOfButton (item, module, type) {
      const { title, action } = item
      switch (module) {
        case 'direction':
          switch (type) {
            case 'down':
              this.directionModuleButtonList = this.directionModuleButtonList.map(v => {
                if (v.title === title) {
                  v.icon = v.iconHighLight
                }
                return v
              })
              // switch (title) {
              //   case '上':
              //     break
              //   case '右':
              //     break
              //   case '下':
              //     break
              //   case '左':
              //     break
              // }
              this.liveDeviceControl(action)
              break
            case 'up':
              this.directionModuleButtonList = this.directionModuleButtonList.map(v => {
                if (v.title === title) {
                  v.icon = v.iconGray
                }
                return v
              })
              break
          }
          break
        case 'zoom':
          switch (type) {
            case 'down':
              this.zoomModuleButtonList = this.zoomModuleButtonList.map(v => {
                if (v.title === title) {
                  v.icon = v.iconGray
                }
                return v
              })
              // switch (title) {
              //   case '加':
              //     break
              //   case '减':
              //     break
              // }
              this.liveDeviceControl(action)
              break
            case 'up':
              this.zoomModuleButtonList = this.zoomModuleButtonList.map(v => {
                if (v.title === title) {
                  v.icon = v.iconHighLight
                }
                return v
              })
              break
          }
          break
      }
    },
    operationOfConfirm () {
      this.$parent.setForActiveForOperationItem('')
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes scaleToShow {
  0% {
    transform: translate(-50%, -50%) scale(0);
  }
  50% {
    transform: translate(-50%, -50%) scale(1.1);
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
  }
}
.vidicon_control {
  width: 600px;
  height: 500px;
  background-color: #3537447e;
  border-radius: 8px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
  animation: scaleToShow 0.3s ease-in 1 alternate forwards;
  .device_title {
    width: 100%;
    height: 82px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .direction_module {
    display: flex;
    justify-content: center;
    .direction_module_circle {
      width: 208px;
      height: 208px;
      background-color: rgba(255, 255, 255, 0.2);
      box-shadow: 0px 0px 11px 2px rgba(53, 55, 68, 0.3),
        inset 0px 1px 3px 0px rgba(216, 216, 216, 0.5);
      border-radius: 50%;
      position: relative;
      .direction_module_circle_button_of_one {
        width: 70px;
        height: 70px;
        position: absolute;
        border-radius: 50%;
        overflow: hidden;
        cursor: pointer;
        user-select: none;
        img {
          width: 100%;
        }
      }
    }
  }
  .zoom_module {
    width: 100%;
    height: 96px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .zoom_module_title {
      position: absolute;
      color: #fff;
      left: 154px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 16px;
    }
    .zoom_module_button_of_one {
      width: 80px;
      height: 32px;
      background: #ffffff;
      border-radius: 6px;
      display: flex;
      justify-content: center;
      align-items: center;
      user-select: none;
      cursor: pointer;
      &:active {
        background: #3982ff;
      }
      img {
        width: 16px;
      }
      &.m_l24 {
        margin-left: 24px;
      }
    }
  }
  .footer_module {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 38px;
    .confirm_btn {
      width: 152px;
      height: 44px;
      background: #3982ff;
      border-radius: 8px;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      user-select: none;
      cursor: pointer;
      font-size: 16px;
      &:hover {
        background: #3369c7;
      }
      &:active {
        background: #3982ff;
      }
    }
  }
}
</style>
